<esa-material-button
    type="clear"
    icon="file_download"
    label="CSV"
    aria-label="Button to download grid as CSV"
    tooltip="Download CSV"
    (click)="exportToCsv()"></esa-material-button>
